class NavbarController {
  constructor() {
    "ngInject";
    this.navVisible = false;
    let self = this;

    $(window).resize(function() {
      if ($(window).width() > 991 ) {
        self.navVisible = false;
      }
    });
  }
}

export default NavbarController;



// WEBPACK FOOTER //
// ./app/components/navbar/navbar.controller.js